<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="relative">
        <div class="vx-navbar-wrapper navbar-full p-0" style="background-image: url('../../../assets/images/pages/img_bg_nav_horizontal.png')">
            <vs-navbar class="navbar-custom navbar-skelton" :class="navbarClasses" :style="navbarStyle"
                       :color="navbarColor" style="background: linear-gradient(120deg, rgba(var(--vs-primary),1) 1%, rgba(var(--vs-primary), .7) 15%, rgba(var(--vs-primary),1) 30%) !important;">

                <!--                <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992"/>-->

                <router-link tag="div" to="/" class="vx-logo cursor-pointer flex items-center">
                    <img src="../../../assets/images/logo/dr.hoangtuan(cam-trang).png" height="40"/>
                </router-link>

                <h-nav-menu :class="[
                  {'text-white' : isNavbarDark  && !isThemeDark},
                  {'text-base'  : !isNavbarDark && isThemeDark}
                ]" :navMenuItems="navMenuItems"/>

                <!--                <search-bar/>-->
                <!--                <feather-icon icon="LockIcon"/>-->
                <div class="flex items-center justify-end">
                    <div class="sm:mr-6 mr-2">
                        <div class="select-workspace flex justify-center items-center">
                            <vs-dropdown>
                                <span class="text-lg text-primary font-semibold flex justify-center items-center">{{ checkWorkspace.toUpperCase() }}
                                    <vs-icon icon="arrow_drop_down" size="small"></vs-icon>
                                </span>

                                <vs-dropdown-menu>
                                    <vs-dropdown-item @click="changeWorkspace('hrm')">
                                        HRM
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="changeWorkspace('crm')">
                                        CRM
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="openInNewTab">
                                        ARM
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>
                    </div>

                    <notification-drop-down/>

                    <profile-drop-down/>
                </div>

            </vs-navbar>
        </div>
    </div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue"
import SearchBar from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown from "./components/ProfileDropDown.vue"
import Logo from "../Logo.vue"
import HNavMenu from "../../components/horizontal-nav-menu/HorizontalNavMenu.vue"

export default {
    name: "the-navbar-horizontal",
    props: {
        logo: {type: String},
        navbarType: {
            type: String,
            required: true
        },
        navMenuItems: {},
        isNavbarDark: {},
        isThemeDark: {}
    },
    components: {
        Logo,
        Bookmarks,
        SearchBar,
        NotificationDropDown,
        ProfileDropDown,
        HNavMenu,
    },
    computed: {
        navbarColor() {
            let color = "#fff"
            if (this.navbarType === "sticky") color = "#f7f7f7"
            else if (this.navbarType === 'static') {
                if (this.scrollY < 50) {
                    color = "#f7f7f7"
                }
            }

            this.isThemedark === "dark" ? color === "#fff" ? color = "#10163a" : color = "#262c49" : null

            return color
        },
        isThemedark() {
            return this.$store.state.theme
        },
        navbarStyle() {
            return this.navbarType === "static" ? {transition: "all .25s ease-in-out"} : {}
        },
        navbarClasses() {
            return this.scrollY > 5 && this.navbarType === "static" ? null : "d-theme-dark-light-bg shadow-none"
        },
        scrollY() {
            return this.$store.state.scrollY
        },
        verticalNavMenuWidth() {
            return this.$store.state.verticalNavMenuWidth
        },
        windowWidth() {
            return this.$store.state.windowWidth
        },
        checkWorkspace() {
            return localStorage.getItem('work_space')
        }
    },
    methods: {
        openInNewTab() {
            window.open('http://arm.drht.vn/', '_blank');
        },
        changeWorkspace(workspace) {
            localStorage.setItem("work_space", workspace);
            setTimeout(() => {
                location.reload()
            }, 500);
            if (workspace === 'hrm') return this.$router.push('/dashboard-hrm').catch(() => {
            });
            if (workspace === 'crm') return this.$router.push('/dashboard-crm').catch(() => {
            });
        }
    }
}

</script>

<style lang="scss">
.select-workspace {
    height: 30px;
    width: 80px;
    background: #fbad18;
    background: linear-gradient(8deg, rgba(255,109,43,1) 44%, rgba(255,169,10,1) 82%);

    border-radius: 1rem;
}
</style>

